import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../Errors/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import UserServicesFactory from '../Services/factory.js'

export class GetBlockedUsersUseCase extends UseCase {
  #config
  #repository
  #currentUserService
  #userNotLoggedInUserError

  constructor({config, repository, currentUserService, userNotLoggedInUserError}) {
    super()
    this.#config = config
    this.#repository = repository
    this.#currentUserService = currentUserService
    this.#userNotLoggedInUserError = userNotLoggedInUserError
  }

  static create({config}) {
    return new GetBlockedUsersUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config}),
      currentUserService: UserServicesFactory.getCurrentUserService({config}),
      userNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  @tracer({metric: 'GetBlockedUsersUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const userEntity = await this.#currentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: 'To get blocked users, the user must be logged in'
        }).toJSON()
      )
    const [error, response] = await this.#repository.getBlockedUsers({userEntity})

    if (error) return Promise.reject(error)
    return response.toJSON()
  }
}

export const factory = GetBlockedUsersUseCase.create
